import React, { useEffect, useState } from 'react';
import { Lock } from 'lucide-react';
export function StickyCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 600);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className={`fixed bottom-0 left-0 right-0 bg-[rgba(10,10,10,.97)] backdrop-blur-[12px] border-t border-[rgba(201,151,43,.25)] p-[12px_24px] flex items-center justify-between z-[100] transition-transform duration-400 ease-out max-md:flex-col max-md:gap-2 max-md:p-[12px_16px] ${isVisible ? 'translate-y-0' : 'translate-y-full'}`} data-id="element-388">
      <div className="max-md:text-center" data-id="element-389">
        <div className="text-[11px] text-gris-texto uppercase tracking-[.08em]" data-id="element-390">
          Código Oscuro
        </div>
        <div className="font-playfair text-[1.5rem] text-dorado-claro max-md:text-[1.2rem]" data-id="element-391">
          <span className="text-[.8rem] text-rojo-vivo line-through mr-[7px] font-sans" data-id="element-392">
            $57
          </span>
          $6.36 USD
        </div>
      </div>
      <a href="#oferta" className="btn-primary animate-shimmer text-[12px] p-[12px_26px] inline-flex items-center justify-center" data-id="element-393">
        
        Acceder ahora
      </a>
    </div>;
}